// extracted by mini-css-extract-plugin
export default {"productDescription":"e_-z","featuredDescription":"f_-z","description":"g_-z","more":"h_-z","descriptionSku":"i_-z"};